import React from 'react'
import { Accordion, AccordionSummary, AccordionDetails, NativeSelect, Typography, InputBase, Grid, Paper, Input, Button } from '@material-ui/core'

import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import Header from '../../../../layout/Header'
import Subheader from '../../../../layout/Subheader'
import Loading from '../../../../components/Loading'

import PhoneMask from '../../../Collaborator/components/PhoneMask'

import { formatDateTimeToRender } from '../../../../utils/functions'

import useStyles from './style'

function Render ({
  inputs,
  getAnchorName,
  ancoraid,
  handleInputChange,
  getErros,
  setErros,
  getCargos,
  getLoading,
  onSubmit
}) {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <Header />
      <Subheader title="Cadastrando contato da rede: " loading={getLoading} back={false} submit={onSubmit} submitText="Cadastrar" subanchor={true} />
      <div className={classes.content}>
        <div className={classes.rootForm} style={{ marginLeft: '5%', width: '90%' }}>
          {getLoading
            ? (<Loading />)
            : (
            <form onSubmit={onSubmit}>
          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className={classes.summary}
            >
              <Typography className={classes.heading}>Informações</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.details}>
              <Grid container>
                <Grid item xs={6}>
                  <label className={classes.label}>Nome</label>
                  <Paper className={classes.medium} elevation={0}>
                  <Input
                      style={{ textTransform: 'uppercase !important' }}
                      className={classes.input}
                      classes={{ input: classes.inputText }}
                      placeholder="Nome"
                      value={inputs.nome}
                      name="nome"
                      onBlur={event => getErros.includes('Nome') && setErros(
                        getErros.filter(function (item) {
                          return item !== 'Nome'
                        })
                      )}
                      error={getErros.includes('Nome')}
                      onChange={handleInputChange}
                      autoComplete="off"
                      inputProps={{
                        maxLength: 100
                      }}
                    />
                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.item}>
                  <label className={classes.label}>Status</label>
                  <Paper className={classes.medium} elevation={0}>
                  <NativeSelect
                      className={classes.input}
                      value={inputs.status}
                      name="status"
                      onChange={handleInputChange}
                      error={getErros.includes('Status')}
                      onBlur={event => getErros.includes('Status') && setErros(
                        getErros.filter(function (item) {
                          return item !== 'Status'
                        })
                      )}
                    >
                      <option value="Ativo">Ativo</option>
                      <option value="Inativo">Inativo</option>
                    </NativeSelect>

                  </Paper>
                </Grid>
                <Grid item xs={6}>
                <label className={classes.label}>E-mail</label>
                  <Paper className={classes.medium} elevation={0}>
                  <Input
                      className={classes.input}
                      placeholder="E-mail"
                      classes={{ input: classes.inputEmail }}
                      value={inputs.email}
                      name="email"
                      onBlur={event => getErros.includes('Email') && setErros(
                        getErros.filter(function (item) {
                          return item !== 'Email'
                        })
                      )}
                      error={getErros.includes('Email')}
                      onChange={handleInputChange}
                      autoComplete="off"
                      inputProps={{
                        maxLength: 100
                      }}
                    />
                  </Paper>
                </Grid>
                <Grid item xs={6}></Grid>
                <Grid item xs={4}>
                  <label className={classes.label}>Telefone 1</label>
                  <Paper className={classes.medium} elevation={0}>
                    <PhoneMask
                      value={inputs.telefone1}
                      name="telefone1"
                      autocomplete="off"
                      error={getErros.includes('Telefone1')}
                      onBlur={event => getErros.includes('Telefone1') && setErros(
                        getErros.filter(function (item) {
                          return item !== 'Telefone1'
                        })
                      )}
                      className={classes.input}
                      placeholder="Telefone 1"
                      onChange={handleInputChange}
                    />
                  </Paper>
                </Grid>
                <Grid item xs={2}>
                  <label className={classes.label}>Ramal 1</label>
                  <Paper className={classes.medium} elevation={0} style={{ width: '91%' }}>
                    <Input
                      value={inputs.ramal1}
                      name="ramal1"
                      error={getErros.includes('Ramal1')}
                      onBlur={(event) => getErros.includes('Ramal1') && setErros(
                          getErros.filter(function (item) {
                            return item !== 'Ramal1';
                          }),
                        )
                      }
                      inputProps={{
                        minLength: 2,
                        maxLength: 5,
                      }}
                      className={classes.input}
                      placeholder="Ramal 1"
                      onChange={(e) => {
                        e.target.value = e.target.value.replace(/\D/g, '');
                        handleInputChange(e);
                      }}
                    />
                  </Paper>
                </Grid>
                <Grid item xs={4} className={classes.item} style={{ paddingLeft: '7px' }}>
                <label className={classes.label}>Telefone 2</label>
                  <Paper className={classes.medium} elevation={0}>
                  <PhoneMask
                      value={inputs.telefone2}
                      name="telefone2"
                      autocomplete="off"
                      error={getErros.includes('Telefone2')}
                      onBlur={event => getErros.includes('Telefone2') && setErros(
                        getErros.filter(function (item) {
                          return item !== 'Telefone2'
                        })
                      )}
                      className={classes.input}
                      placeholder="Telefone 2"
                      onChange={handleInputChange}
                    />
                  </Paper>
                </Grid>
                <Grid item xs={2} className={classes.item}>
                  <label className={classes.label} style={{ width: '90%' }}>Ramal 2</label>
                  <Paper className={classes.medium} elevation={0} style={{ width: '91%' }}>
                    <Input
                      value={inputs.ramal2}
                      name="ramal2"
                      error={getErros.includes('Ramal2')}
                      onBlur={(event) => getErros.includes('Ramal2') && setErros(
                          getErros.filter(function (item) {
                            return item !== 'Ramal2';
                          }),
                        )
                      }
                      inputProps={{
                        minLength: 2,
                        maxLength: 5,
                      }}
                      className={classes.input}
                      placeholder="Ramal 2"
                      onChange={(e) => {
                        e.target.value = e.target.value.replace(/\D/g, '');
                        handleInputChange(e);
                      }}
                    />
                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <label className={classes.label}>Receber Email das Antecipacoes Aprovadas</label>
                  <Paper className={classes.medium} elevation={0}>
                  <NativeSelect
                      className={classes.input}
                      value={inputs.receberEmailAntecipacoesAprovadas}
                      name="receberEmailAntecipacoesAprovadas"
                      onChange={handleInputChange}
                      error={getErros.includes('ReceberEmailAntecipacoesAprovadas')}
                      onBlur={event => getErros.includes('ReceberEmailAntecipacoesAprovadas') && setErros(
                        getErros.filter(function (item) {
                          return item !== 'ReceberEmailAntecipacoesAprovadas'
                        })
                      )}
                    >
                      <option value="NaoRecebe">Não Recebe</option>
                      <option value="RecebePrincipal">Recebe Principal</option>
                      <option value="RecebeCopia">Recebe Cópia</option>
                    </NativeSelect>

                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.item}>
                  <label className={classes.label}>Receber Email de Fechamento do Mes</label>
                  <Paper className={classes.medium} elevation={0}>
                  <NativeSelect
                      className={classes.input}
                      value={inputs.receberEmailFechamentoMes}
                      name="receberEmailFechamentoMes"
                      onChange={handleInputChange}
                      error={getErros.includes('ReceberEmailFechamentoMes')}
                      onBlur={event => getErros.includes('ReceberEmailFechamentoMes') && setErros(
                        getErros.filter(function (item) {
                          return item !== 'ReceberEmailFechamentoMes'
                        })
                      )}
                    >
                      <option value="NaoRecebe">Não Recebe</option>
                      <option value="RecebePrincipal">Recebe Principal</option>
                      <option value="RecebeCopia">Recebe Cópia</option>
                    </NativeSelect>

                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <label className={classes.label}>Cargo</label>
                  <Paper className={classes.medium} elevation={0}>
                    <NativeSelect
                      className={classes.input}
                      value={inputs.cargoId}
                      name="cargoId"
                      onChange={handleInputChange}
                      error={getErros.includes('CargoId')}
                      onBlur={event => getErros.includes('CargoId') && setErros(
                        getErros.filter(function (item) {
                          return item !== 'CargoId'
                        })
                      )}
                    >
                      <option value="0">FALTA PREENCHER</option>
                      {getCargos.map(cargo => (
                        <option key={cargo.cargoId} value={cargo.cargoId}>{cargo.cargo}</option>
                      ))}
                    </NativeSelect>
                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <label className={classes.label}>Autoriza Antecipação Terceiros</label>
                  <Paper className={classes.medium} elevation={0}>
                  <NativeSelect
                      className={classes.input}
                      value={inputs.autorizaAntecipacaoTerceiros}
                      name="autorizaAntecipacaoTerceiros"
                      onChange={handleInputChange}
                      error={getErros.includes('AutorizaAntecipacaoTerceiros')}
                      onBlur={event => getErros.includes('AutorizaAntecipacaoTerceiros') && setErros(
                        getErros.filter(function (item) {
                          return item !== 'AutorizaAntecipacaoTerceiros'
                        })
                      )}
                    >
                      <option value="Nao">Não</option>
                      <option value="Sim">Sim</option>
                    </NativeSelect>
                  </Paper>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>

          <div className={classes.divButton}>
            <Button variant="contained" type="submit" className={classes.button}>Cadastrar</Button>
          </div>
          </form>
              )}
        </div>

      </div>
    </div>
  )
}

export default Render
